import React, { Component } from 'react';
import {StyleSheet, Text, TextInput, View, Animated, SafeAreaView, Pressable, FlatList, Easing, Dimensions, Image} from 'react-native';

import { Checkbox } from 'react-native-paper';

import GameData from './GameData';

import * as Font from 'expo-font';

import TaskImages from './Images';

import { Overlay } from 'react-native-elements';

const fps = 10;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

class OptionsScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
		showOverlay: false,
		overlayTitle: "",
		overlayText: "",
		overlayYes: null,
		overlayNo: null,
		overlaySave: null,
		overlayLoad: null,
		overlayImport: null,
		overlayExport: null,
		overlayInput: false,
		textInput: "",
		refresh: false,
    }
	
	
	GameData.optionsScreen = this;
  }
  
  loadRefresh() {
	  this.setState({refresh: !this.state.refresh});	
  }
  
  viewEnding() {
	  this.setState({showOverlay: true, overlayTitle: "Time of Death",
					overlayText: "I pick up my phylactery and feel the warmth of my soul. Death, Time has been restored. I look at Gavriel, and see a happy tear. What was once immortal man, is reduced to Dust.\n\n\n\nThanks for playing! I hope you enjoyed Lich Baby.",
					});	  
  }
  
  confirmPrestige() {
	  this.setState({showOverlay: true, overlayTitle: "Prestige?",
			overlayText: "Start the game over but with increased threat generation?",
			overlayYes: this.prestige,
		});		  
  }
  
  prestige() {
	  GameData.prestige();
	  this.closeOverlay();
	  this.props.navigation.navigate('Home')	  
  }
  
  confirmAssistance() {
	  this.setState({showOverlay: true, overlayTitle: "Assisted Living?",
					overlayText: "Assisted living is an experimental tool to aid your planning. Warning there is an impact on performance.",
					overlayYes: this.turnOnAssistance,
					overlayNo: this.turnOffAssistance,
					});	  
  }
  
  turnOnAssistance() {
	  GameData.assistance = true;
	  this.closeOverlay();
  }
  
  turnOffAssistance() {
	  GameData.assistance = false;
	  //GameData.resetInventory();
	  this.closeOverlay();
  }
  
  confirmWipe() {
	  this.setState({showOverlay: true, overlayTitle: "Wipe Data?",
					overlayText: "Are you sure you want to erase your game data? There is no going back.",
					overlayYes: this.wipeData});
  }
  
  saveLoadLife(life) {
	  this.life = life;
	  this.setState({showOverlay: true, overlayTitle: "Save / Load Life?",
					overlayText: "",
					overlaySave: this.saveLife,
					overlayLoad: this.loadLife});
  }
  
  async saveLife() {
	  await GameData.saveLife(this.life);
	  this.closeOverlay();
  }
  
  async loadLife() {
	  await GameData.loadLife(this.life);
	  this.closeOverlay();
	  this.props.navigation.navigate('Home');
  }
  
  importExport() {
	  this.setState({showOverlay: true, overlayTitle: "Import or Export",
					overlayText: "To Import, paste saved data into the input field and the press import.\n\nTo export, press export then copy and save the data from the input field.",
					overlayInput: true,
					overlayImport: this.importData,
					overlayExport: this.exportData});
  }
  
  saveExport(userInput) {
	  this.setState({textInput: userInput});
  }
  
  async importData() {
	  let saveAttempt = await GameData.importSaveData(this.state.textInput);
	  if (saveAttempt) {
		this.setState({showOverlay: true, overlayTitle: "Success!",
			overlayText: "",
			overlayInput: false,
			overlayImport: null,
			overlayExport: null});
	  } else {
		this.setState({showOverlay: true, overlayTitle: "Failure!",
			overlayText: "Make sure the entire encoded save has been copied. Save may be from an outdated version of the game.",
			overlayInput: false,
			overlayImport: null,
			overlayExport: null});		  
	  }
  }
  
  async exportData() {
	  if (GameData.homeScreen.lifeRunning){
		  //let encoded = await GameData.getEncodedSave();
		  this.setState({textInput: "Please stop run before exporting"});
	  }
	  else {
		  let encoded = await GameData.getEncodedSave();
		  this.setState({textInput: encoded});
	  }
  }
  
  wipeData() {
	  GameData.wipeData();
	  this.setState({showOverlay: true, overlayTitle: "Data Wiped!",
					overlayText: "Please reload the game to restart.",
					overlayYes: null});
  }
  
  closeOverlay() {
	this.setState({
		showOverlay: false,
		overlayTitle: "",
		overlayText: "",
		overlayYes: null,
		overlayNo: null,
		overlaySave: null,
		overlayLoad: null,
		overlayImport: null,
		overlayExport: null,
		overlayInput: false,
		textInput: "",
		refresh: false,
    });
  }
  


  render() {
	  let overlayYes = null
	  let overlayNo = null
	  if (this.state.overlayYes) {
		  overlayYes =  <Pressable onPress={this.state.overlayYes.bind(this)}>
            <Text style={styles.overlayPress}>Yes</Text>
          </Pressable>
	  }
	  if (this.state.overlayNo) {
		  overlayNo =  <Pressable onPress={this.state.overlayNo.bind(this)}>
            <Text style={styles.overlayPress}>No</Text>
          </Pressable>
	  }
	  if (this.state.overlaySave) {
		  overlayYes =  <View style={styles.saveLoadContainer}>
		  <Pressable onPress={this.state.overlaySave.bind(this)}>
            <Text style={styles.overlayPress}>Save</Text>
          </Pressable>
		  <Pressable onPress={this.state.overlayLoad.bind(this)}>
            <Text style={styles.overlayPress}>Load</Text>
          </Pressable>
		  </View>
	  }
	  if (this.state.overlayImport) {
		  overlayYes =  <View style={styles.saveLoadContainer}>
		  <TextInput
		    editable
		    multiline
			selectable={true}
		    style={styles.input}
			onChangeText={this.saveExport.bind(this)}
			value={this.state.textInput}
		  />
		  <View>
		  <Pressable onPress={this.state.overlayImport.bind(this)}>
            <Text style={styles.overlayPress}>Import</Text>
          </Pressable>
		  <Pressable onPress={this.state.overlayExport.bind(this)}>
            <Text style={styles.overlayPress}>Export</Text>
          </Pressable>
		  </View>
		  </View>
	  }
    return (
      <View style={styles.container}>
	  <Overlay visible={this.state.showOverlay} onBackdropPress={this.closeOverlay.bind(this)} overlayStyle={styles.overlayStyle}>
          <Text style={styles.overlayTitle}>{this.state.overlayTitle}</Text>
          <Text style={styles.overlayText}>{this.state.overlayText}</Text>
		  <View style={styles.yesnoContainer}>
			  {overlayYes}
			  {overlayNo}
		  </View>	  
		  <Pressable onPress={this.closeOverlay.bind(this)}>
            <Text style={styles.overlayPress}>Close</Text>
          </Pressable>
        </Overlay>
        <Text style={styles.screenTitle}>Options</Text>
		
		<Text style={styles.optionText}>Lifestyles</Text>
		<View style={styles.lifeContainer}>
		  <Pressable onPress={this.saveLoadLife.bind(this, 'A')} style={styles.lifeButton}>
            <Text style={styles.optionText}>A</Text>
          </Pressable>
		  <Pressable onPress={this.saveLoadLife.bind(this, 'B')} style={styles.lifeButton}>
            <Text style={styles.optionText}>B</Text>
          </Pressable>
		  <Pressable onPress={this.saveLoadLife.bind(this, 'C')} style={styles.lifeButton}>
            <Text style={styles.optionText}>C</Text>
          </Pressable>
        </View>
        <View style={styles.optionsContainer}>
		  <Pressable onPress={this.confirmAssistance.bind(this)} style={styles.actionButton}>
            <Text style={styles.optionText}>Assisted Living</Text>
          </Pressable>
		  <Pressable onPress={this.importExport.bind(this)} style={styles.actionButton}>
            <Text style={styles.optionText}>Import/Export</Text>
          </Pressable>
		  <Pressable onPress={this.confirmWipe.bind(this)} style={styles.actionButton}>
            <Text style={styles.optionText}>Wipe Data</Text>
          </Pressable>
        </View>
		{GameData.gameBeaten &&
		<Pressable onPress={this.viewEnding.bind(this)} style={styles.actionButton}>
            <Text style={styles.optionText}>View Ending</Text>
          </Pressable>
		}
		{GameData.gameBeaten && GameData.prestigeAmount == 0 &&
		<Pressable onPress={this.confirmPrestige.bind(this)} style={styles.actionButton}>
            <Text style={styles.optionText}>Prestige</Text>
          </Pressable>
		}
      </View >
    )
  }
}

/*
		<View style={styles.optionsContainer}>
		<Text style={styles.optionText}>Stats:</Text>
		<Text style={styles.optionText}>Lives Lived: {GameData.totalLives}</Text>
		{GameData.prestigeAmount > 0 &&
		  <Text style={styles.optionText}>Prestige: {GameData.prestigeAmount}</Text>
		  }
		</View>
		*/


const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    flex: 1,
    backgroundColor: '#000000',
	borderBottomWidth: 2,
    borderColor: '#ffffff',
  },
   screenTitle: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 24,
    textAlign: 'center',
    borderBottomWidth: 2,
    borderColor: '#ffffff',
  },
  optionsContainer: {
    flex: 1,
  },
  saveLoadContainer: {
	flexDirection: "row",
	justifyContent: 'space-around',
	alignContent: 'center',
  },
  lifeContainer: {
    //flex: 1,
	flexDirection: "row",
	justifyContent: 'space-around',
	alignContent: 'center',
  },
   yesnoContainer: {
    //flex: 1,
	flexDirection: "row",
	hieght: 'auto',
	width: 'auto',
	//justifyContent: 'space-around',
	alignContent: 'center',
	alignSelf: 'center',
  }, 
  optionText: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 24,
    textAlign: 'left',
    alignSelf: 'center',
  },
  optionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
  },
    overlayStyle: {
    borderWidth: 2,
    padding: 20,
    maxWidth: '98%',
    fontFamily: 'Alegreya-Regular',
    borderColor: '#ffffff',
    backgroundColor: '#000000'
  },
  overlayTitle: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'center',
    textDecorationLine: 'underline',
    fontSize: 24,
  },
  overlayText: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'left',
    fontSize: 16,
  },
  overlayPress: {
    borderWidth: 2,
    borderRadius: 6,
    padding: 4,
    margin: 5,
	fontSize: 20,
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    borderColor: '#ffffff',
    backgroundColor: '#000000',
    textAlign: 'center',
    alignSelf: 'center',
  },
  lifeButton: {
    //alignItems: 'center',
    //width: '100%',
    //justifyContent: 'center',
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
  },
  input: {
    backgroundColor: '#ffffff',
	width: 100,
	height: 100,
	padding: 5,
  },  
});

export default OptionsScreen;